import type { LoaderFunction, RouteObject } from "react-router-dom";
import { waitForSofipoToken } from "@/utils/authToken";
import { inApp } from "@/common/js/constant";

// 包装单个 loader：端内先等待 App token 初始化完成，再执行原 loader。
function wrapLoader(loader: LoaderFunction): LoaderFunction {
  return async (args) => {
    if (inApp) {
      await waitForSofipoToken();
    }
    return loader(args);
  };
}

// 递归包装整个路由配置，确保当前路由和后续新增的嵌套路由 loader 都统一等待 token。
export function withTokenReady(routes: RouteObject[]): RouteObject[] {
  return routes.map((route) => {
    const wrappedRoute = {
      ...route,
      ...(route.loader ? { loader: wrapLoader(route.loader) } : {}),
      ...(route.children ? { children: withTokenReady(route.children) } : {}),
    };
    return wrappedRoute as RouteObject;
  });
}
